import { render, staticRenderFns } from "./BbqueryProduct.vue?vue&type=template&id=6cadd587&scoped=true"
import script from "./BbqueryProduct.vue?vue&type=script&lang=js"
export * from "./BbqueryProduct.vue?vue&type=script&lang=js"
import style0 from "./BbqueryProduct.vue?vue&type=style&index=0&id=6cadd587&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cadd587",
  null
  
)

export default component.exports